const DEFAULTS =   {
  // Selector used to find the observable children
  observeSelector: '[data-in-view-attr]',
};

export default class inViewAttribute {
  
  constructor(el, options = DEFAULTS) {
    // Merge options
    this.options = {...DEFAULTS, ...options};

    // Collect attributes to be added once element is in view.
    this.attributes = Object.keys(el.dataset).filter(this._inViewAttr);

    // Create the observer
    this.observer = this._createIntersectionObsvr();
    this.observer.observe(el);
  }

  /**
   * Create an IntersectionObserver...
   * @return {IntersectionObserver}
   */
  _createIntersectionObsvr() {
    return new IntersectionObserver(changes => {
      changes.forEach(({ intersectionRatio, target }) => {
        if (intersectionRatio > 0) {
          this.attributes.forEach(attr => {
            if (this._getAttr(attr) === 'style') {
              target.setAttribute('style', target.dataset[attr]);
            } else {
              target[this._getAttr(attr)] = target.dataset[attr];
            }
          });
          this.observer.unobserve(target);
        }
      });
    }, {
      threshold: [0, 1],
    });
  }

  _inViewAttr(string) {
    return string.substring(0,6) === 'inView' && string !== 'inViewAttr';
  }

  _getAttr(inViewAttr) {
    return inViewAttr.substring(6, inViewAttr.length).toLowerCase();
  }


}
